import React from 'react';
import debounce from 'debounce';
import PropTypes from 'prop-types';
import { Provider } from './scrollContext';

export default class ScrollingProvider extends React.Component {
  static propTypes = {
    /** ms. to wait until the calculation of the current section */
    debounceDelay: PropTypes.number,
    /** scrolling style */
    scrollBehavior: PropTypes.oneOf(['auto', 'smooth']),
    /** React component */
    children: PropTypes.node,
  };

  static defaultProps = {
    debounceDelay: 50,
    scrollBehavior: 'smooth',
    children: null,
  };

  state = {
    selected: '',
  };

  refList = {};

  componentDidMount() {
    document.addEventListener('scroll', this.debounceScroll, true);
    this.handleScroll();
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.debounceScroll, true);
  }

  handleScroll = () => {
    if (this.isProgrammaticScroll) return; //RITM1405215
    const selected = Object.entries(this.refList).reduce(
      (acc, [key, value]) => {
        if (value.current) {
          const { top } = value.current.getBoundingClientRect();
          if (top) {
            const differenceFromTop = Math.abs(top);

            if (acc)
              return differenceFromTop < acc.differenceFromTop
                ? {
                    differenceFromTop,
                    key,
                  }
                : acc;
          }
        }
      },
      {
        differenceFromTop: 9999,
        key: '',
      }
    );

    //if (selected) this.setState({ selected: selected.key });
    if (selected) this.setState({ selected: selected.key }, () => { console.log("Updated handleScroll selected:", this.state.selected); }); //RITM1405215
  };

  // eslint-disable-next-line
  debounceScroll = debounce(this.handleScroll, this.props.debounceDelay || 50);

  registerRef = (id) => {
    const newRef = React.createRef();
    this.refList = { ...this.refList, [id]: newRef };
    return newRef;
  };

  scrollTo = (section) => {
    const { scrollBehavior: behavior } = this.props;
    const sectionRef = this.refList[section];
    if (!sectionRef) return console.warn('Section ID not recognized!');

    //RITM1405215
    // const top = sectionRef.current.offsetTop - 185;

    // return this.setState({ selected: section }, () =>
    //   window.scrollTo({
    //     top,
    //     behavior,
    //   })
    // );

    this.isProgrammaticScroll = true;
    const rect = sectionRef.current.getBoundingClientRect(); 
    const scrollTop = window.scrollY; // This gives the exact document position of the element 
    const target = rect.top + scrollTop - 135;

    window.scrollTo({
      top : target,
      behavior,
    });

    setTimeout(() => {
      this.isProgrammaticScroll = false;
    }, 400);
    return this.setState({ selected: section }, () => { console.log("Updated scrollTo selected:", this.state.selected); });
    //End
  };

  render() {
    const { selected } = this.state;
    const { children } = this.props;

    const value = {
      registerRef: this.registerRef,
      scrollTo: this.scrollTo,
      refList: this.refList,
      selected,
    };
    return <Provider value={value}>{children}</Provider>;
  }
}
